import React from 'react';
import { XMarkIcon, PhotoIcon } from '@heroicons/react/24/outline';

const ImageUploadPreview = ({ image, onRemove, onChange }) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        alert('Image size should be less than 10MB');
        return;
      }
      
      // Convert to base64 for preview only - upload happens on submit
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({
          file: reader.result, // base64 string for preview
          filename: file.name,
          mimetype: file.type,
          size: file.size,
          actualFile: file // Keep the actual file for upload on submit
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Image (Optional)
        </label>
        {image && (
          <button
            type="button"
            onClick={onRemove}
            className="text-red-500 hover:text-red-700 text-sm font-medium flex items-center"
          >
            <XMarkIcon className="h-4 w-4 mr-1" />
            Remove Image
          </button>
        )}
      </div>

      {!image ? (
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-400 transition-colors">
          <PhotoIcon className="mx-auto h-12 w-12 text-gray-400" />
          <div className="mt-4">
            <label className="cursor-pointer">
              <span className="mt-2 block text-sm font-medium text-gray-900">
                Click to upload image
              </span>
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleImageChange}
              />
              <span className="mt-1 block text-xs text-gray-500">
                PNG, JPG, WebP up to 10MB
              </span>
            </label>
          </div>
        </div>
      ) : (
        <div className="relative">
          <img
            src={image.file}
            alt="Preview"
            className="w-full max-w-md rounded-lg border border-gray-300"
            style={{ maxHeight: '300px', objectFit: 'contain' }}
          />
          <div className="mt-2 text-sm text-gray-600">
            <p><strong>File:</strong> {image.filename}</p>
            <p><strong>Size:</strong> {(image.size / 1024).toFixed(1)} KB</p>
            <p><strong>Type:</strong> {image.mimetype}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploadPreview;